<template>
  <div
    class="grid-items my-1 border border-gray-200 rounded-md px-4 h-24 grid w-full items-center"
  >
    <div v-if="item.mainImage">
      <img :src="item.mainImage" class="w-20" />
    </div>
    <div v-else>
      <img src="@/assets/img/no-image-found.png" class="w-20" />
    </div>
    <div class="text-center">
      {{ item.nkrCode }}
    </div>
    <div class="text-center">
      {{ item.unificado }}
    </div>
    <div class="text-center">
      {{ item.description }}
    </div>
    <div class="text-center">
      <button
        class="bg-red-300 rounded-md w-10 p-1"
        @click="deleteCategory()"
        v-if="!deleteInit"
      >
        <img src="@/assets/icons/trash.svg" alt="delete" class="w-full" />
      </button>
      <div v-else class="grid grid-cols-2 gap-2">
        <button class="btn-error-button" @click="deleteInit = false">
          Cancel
        </button>
        <button class="btn-success-button" @click="confirmDeleteCategory()">
          confirm
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { deleteCategoryFromProduct } from "@/api/store/CategoriesService.js";

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deleteInit: false
    };
  },
  methods: {
    deleteCategory() {
      this.deleteInit = true;
    },
    confirmDeleteCategory() {
      deleteCategoryFromProduct(this.item.relationId)
        .then(() => {
          this.$toast.open({
            message: `Relation removed`,
            type: "success",
            position: "top-right"
          });
          this.$emit("relationDeleted");
        })
        .catch(() => {
          this.$toast.open({
            message: `error on deletion`,
            type: "error",
            position: "top-right"
          });
        });
    }
  }
};
</script>
<style lang="postcss" scoped>
.grid-items {
  grid-gap: 10px;
  grid-template-columns: 100px 150px 150px 1fr 140px;
}
</style>
